// TODO: REMOVE after BETA PHASE

export const aiWorkflowsAllowedEmails = [
	'julia.kaupert+customer@agilox.net',
	'harald.eriksson@agilox.net',
	'ruediger.fake@gmail.com',
	'raffael.prem@agilox.net',
	'raffael.prem+customer@agilox.net',
	'jessica.holly@agilox.net',
	'david.niedermaier@agilox.net',
	'markus.skof@agilox.net',
	'aldin.bradaric@agilox.net',
	'julia.kaupert@agilox.net',
	'alexander.hollerweger@agilox.net',
	'felix.pfusterer@agilox.net',
	'daniel.danciu@agilox.net',
	'philipp.lacherstorfer@agilox.net',
	'marc.koppler@agilox.net',
	'miriam.leutgeb@agilox.net',
	'dmitry.maklakov@agilox.net',
	'sebastian.schuerz@agilox.net',
	'zoltan.budai@agilox.net',
	'david.niedermaier@agilox.net',
	'julia.kaupert@agilox.net',
	'cathy.budai-fricke@agilox.net',
	'jan.schoenegger@agilox.net',
	'daniel.oviedo@agilox.net',
	'michael.pollak@agilox.net',
];

/**
 * Controls the Workflow Editor (non-AI) in the Plan App.
 */
export const workflowsAllowedEmails = [
	'julia.kaupert+customer@agilox.net',
	'raffael.prem@agilox.net',
	'raffael.prem+customer@agilox.net',
	'jessica.holly@agilox.net',
	'aldin.bradaric@agilox.net',
	'julia.kaupert@agilox.net',
	'alexander.hollerweger@agilox.net',
	'felix.pfusterer@agilox.net',
	'daniel.danciu@agilox.net',
	'philipp.lacherstorfer@agilox.net',
	'roland.mate@agilox.net',
	'marc.koppler@agilox.net',
	'miriam.leutgeb@agilox.net',
	'dmitry.maklakov@agilox.net',
	'sebastian.schuerz@agilox.net',
	'zoltan.budai@agilox.net',
	'harald.eriksson@agilox.net',
];
